import React from 'react'
import { Box, Skeleton, Chip, Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'

const ClaimUploadListSkeleton = () => {
  const { t } = useTranslation()
  const skeletonItems = 4

  return (
    <div className='pre_auth_container !p-0'>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mb: 3,
          alignItems: 'center'
        }}
      >
        <Box>
          <Skeleton
            variant='text'
            width={200}
            height={40}
            sx={{ fontSize: '1.5rem' }}
          />
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Skeleton variant='rounded' width={180} height={40} />
          <Skeleton variant='rounded' width={120} height={40} />
        </Box>
      </Box>

      <div className='grid grid-cols-1 gap-3'>
        {Array.from({ length: skeletonItems }).map((_, index) => (
          <div
            key={index}
            className='card shadow-md p-2 rounded-md grid grid-cols-7'
          >
            <div className='eligibility_details_user_data'>
              <div className='mb-2 pt-1 bg-secondry !rounded-tl-md'>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
              <div>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
            </div>

            <div className='eligibility_details_user_data'>
              <div className='mb-2 pt-1 bg-secondry'>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
              <div>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
            </div>

            <div className='eligibility_details_user_data'>
              <div className='mb-2 pt-1 bg-secondry'>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
              <div>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
            </div>

            <div className='eligibility_details_user_data'>
              <div className='mb-2 pt-1 bg-secondry'>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
              <div>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
            </div>

            <div className='eligibility_details_user_data'>
              <div className='mb-2 pt-1 bg-secondry'>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
              <div>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
            </div>

            <div className='eligibility_details_user_data'>
              <div className='mb-2 pt-1 bg-secondry'>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
              <div>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Skeleton variant='rounded' width={80} height={24} />
                </Box>
              </div>
            </div>

            <div className='eligibility_details_user_data'>
              <div className='mb-2 pt-1 bg-secondry !rounded-tr-md'>
                <Skeleton
                  variant='text'
                  width='80%'
                  height={20}
                  sx={{ mx: 'auto' }}
                />
                <Skeleton
                  variant='text'
                  width='60%'
                  height={25}
                  sx={{ mx: 'auto', mt: 1 }}
                />
              </div>
              <div className='flex gap-3 !text-center justify-center items-center pt-1'>
                {Array.from({ length: 4 }).map((_, i) => (
                  <Skeleton key={i} variant='circular' width={24} height={24} />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ClaimUploadListSkeleton
